import React, { memo, useCallback } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'

import { INearByTour, IAroundMe } from '../../common'
import { IToursConnection, TourOrderByEnum, OrderByDirectionEnum, ICountry, ILocation } from '../../../../store';
import { NearByNav } from './nearByNav';
import CategoryNav from './categoryNav'
import SelectedTopCategoryName from './selectedTopCategory'
import { ToursSectionStoreDispatchAction, withToursSectionStoreValue, EToursSectionStateActionTypes } from '../../store';

interface IToursHeaderToursStoreProps {
    dispatch: ToursSectionStoreDispatchAction
    toursTotal: number
    orderBy: TourOrderByEnum
    orderByDirection: OrderByDirectionEnum
    showMap: boolean
    showCategories: boolean
}

const ToursHeader = memo(withRouter((props: RouteComponentProps & IToursHeaderToursStoreProps) => {
    console.log("Render tours Header")
    const { location: { state: { country = undefined, location = undefined, filterByRegion = undefined, aroundMe = undefined, searchText = undefined, nearByTour = undefined } = {} } } = props
    const { toursTotal, orderBy, orderByDirection, showMap, showCategories, dispatch } = props
    const actualCountry = country as ICountry
    const actualLocation = location as ILocation
    const actualAroundMe = aroundMe as IAroundMe
    const actualSearchText = searchText as string
    const actualNearByTour = nearByTour as INearByTour
    const { t } = useTranslation()

    const toggleOrderByDirection = useCallback(() => dispatch({ type: EToursSectionStateActionTypes.ToggleOrderByDirection}), [])
    const mapToggle = useCallback(() => dispatch({ type: EToursSectionStateActionTypes.ToggleShowMap}), [])
    const categoriesToggle = useCallback(() => dispatch({ type: EToursSectionStateActionTypes.ToggleShowCategories}), [])

    return (
        <>
            {!actualNearByTour && <CategoryNav/>}
            {actualNearByTour && <NearByNav
                tour={actualNearByTour.tour}
            />}
            <div className="page-header-part page-header" style={{padding: '0px 15px', maxWidth: '100rem', margin: "0 auto" }}>
                <div className="page-title">
                    <h4 className={'m-tb5'}>
                        {toursTotal} <SelectedTopCategoryName/> {actualNearByTour ? `${t('found around')} '${actualNearByTour.tour.title}'` : actualAroundMe ? t('found around me') : t('found in')} {actualCountry && actualCountry.title} {actualLocation && `, ${actualLocation.region}`} {actualLocation && !filterByRegion && `, ${actualLocation.city}`} {actualSearchText && `${t('for')} '${actualSearchText}'`}
                    </h4>
                </div>
                <div className="tool-bar">
                    <label className="p-r5">{t('Sort by')}: </label>
                    <select className="small" value={orderBy} onChange={e => dispatch({ type: EToursSectionStateActionTypes.SetOrderBy, orderBy: +e.target.value})}>
                        {[{ name: 'Date', val: TourOrderByEnum.date }, { name: 'Title', val: TourOrderByEnum.title }, { name: 'Views', val: TourOrderByEnum.views }].map(item => (
                            <option key={item.name} value={item.val}>{t(item.name)}</option>
                        ))}
                    </select>
                    {orderByDirection === OrderByDirectionEnum.asc
                        ? <ArrowUpwardIcon style={{ verticalAlign: 'middle' }} onClick={toggleOrderByDirection} />
                        : <ArrowDownwardIcon style={{ verticalAlign: 'middle' }} onClick={toggleOrderByDirection} />
                    }
                    <div className="toggle-button">
                        <button className={`grid ${!showMap ? 'active' : ''}`} onClick={mapToggle} >
                            {t('Grid')}
                        </button>
                        <button className={`map ${showMap ? 'active' : ''}`} onClick={mapToggle}>
                            {t('Map')}
                        </button>
                    </div>
                    <div className="toggle-button">
                        <button className={`category ${showCategories === true ? 'active' : ''}`} onClick={categoriesToggle}>
                            {t('Category')}
                        </button>
                        <button className="location">
                            {t('Location')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}))

export default withToursSectionStoreValue<IToursHeaderToursStoreProps>(ToursHeader, ['dispatch', 'toursTotal', 'orderBy', 'orderByDirection', 'showCategories', 'showMap'])